import { render, staticRenderFns } from "./MenuDebtor.vue?vue&type=template&id=cc4e6b4a&scoped=true&"
import script from "./MenuDebtor.vue?vue&type=script&lang=js&"
export * from "./MenuDebtor.vue?vue&type=script&lang=js&"
import style0 from "./MenuDebtor.vue?vue&type=style&index=0&id=cc4e6b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4e6b4a",
  null
  
)

export default component.exports